<template>
  <v-card>
    <v-card-title>
      Manage Notifications
    </v-card-title>
    <v-card-subtitle>
      Manage how and if notifications are delivered
    </v-card-subtitle>
    <v-card-text>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">
                Notification
              </th>
              <th class="text-left">
                Email
              </th>
              <th class="text-left">
                Text
              </th>
              <th
                class="text-left"
                v-if="
                  profile.integrationIds.includes($enums.integrations.SLACK)
                "
              >
                Slack
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in notifications" :key="item.notificationTypeId">
              <td>{{ name(item.notificationTypeId) }}</td>
              <td>
                <v-checkbox
                  v-model="item.email"
                  :disabled="lookup(item.notificationTypeId).required"
                ></v-checkbox>
              </td>
              <td>
                <v-checkbox
                  v-model="item.text"
                  v-if="lookup(item.notificationTypeId).allowText"
                ></v-checkbox>
              </td>
              <td>
                <v-checkbox
                  v-model="item.slack"
                  v-if="
                    profile.integrationIds.includes(
                      $enums.integrations.SLACK
                    ) && lookup(item.notificationTypeId).allowSlack
                  "
                ></v-checkbox>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save" :loading="saving">
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "UserProfileNotifications",
  data: () => ({
    saving: false,
    notifications: []
  }),
  computed: {
    ...mapGetters({
      profile: "profile/profile",
      notification_types: "lookup/notification_types"
    })
  },
  created() {
    this.setNotifications();
  },
  methods: {
    setNotifications() {
      this.notifications = (this.notification_types || []).map(x => {
        let item = this.profile.notifications.find(
          y => y.notificationTypeId == x.id
        ) || { notificationTypeId: x.id, email: true, text: false };
        if (x.required) {
          item.email = true;
        }
        return item;
      });
    },
    name(id) {
      switch (id) {
        case this.$enums.notifications.PULSE:
          return "Culture Tracking";
        case this.$enums.notifications.SURVEY:
          return "Custom Surveys";
        case this.$enums.notifications.RESOURCE:
          return "Training Resources";
        case this.$enums.notifications.TASK_REMINDER:
          return "Task Reminder";
        case this.$enums.notifications.RECOGNITION:
          return "Recognition";
        case this.$enums.notifications.EMPLOYEE_RECOGNITION:
          return "Employee Recognitions";
        case this.$enums.notifications.URGENT_TALKING_POINT:
          return "Urgent Talking Points Created";
        case this.$enums.notifications.FEEDBACK_ACKNOWLEDGED:
          return "Anonymous Feedback Acknowledged";
        case this.$enums.notifications.FEEDBACK_RECEIVED:
          return "Anonymous Feedback Received";
        case this.$enums.notifications.MEETING_STARTED:
          return "Meeting Started";
        case this.$enums.notifications.MEETING_ENDED:
          return "Meeting Ended";
      }
    },
    lookup(id) {
      let item = this.notification_types.find(x => x.id == id);
      if (item) {
        return item;
      }
      return {};
    },
    save() {
      this.saving = true;
      this.$store
        .dispatch("profile/saveProfileNotifications", this.notifications)
        .then(() => {
          this.$root.$snackbarSuccess("Profile Notifications saved.");
          this.setNotifications();
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occurred while saving your profile notifications."
          );
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
